import { useContext, useEffect, useRef, useState } from "react";
import { getDays } from "../api/daysService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { addClassroom } from "../api/classroomService";

const AddClassroomComponent = (props) => {
    const navigate = useNavigate();
    const closeRef = useRef();

    const [isAdding, setIsAdding] = useState(false);
    const [className, setClassName] = useState("");

    useEffect(() => {

    }, []);

    const insertClassroom = async (e) => {
        try {
            const data = await addClassroom(className);
            afterInsert(data.classroom);
            // console.log(days);
        } catch (err) {
            toast(err.response?.data?.message);
        }
    };

    const afterInsert = (classroom) => {
        props.afterAddClassroom(classroom.id, classroom.name);
        setClassName("");
        closeRef.current.click();
    }

    return (
        <div class="modal fade" id="AddClassroomModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">افزودن کلاس</h1>
                    </div>
                    <div class="modal-body">
                        <input value={className} onChange={(e) => setClassName(e.target.value)} className="form-control" type="text" placeholder="نام کلاس" />
                    </div>
                    <div class="modal-footer">
                        <button ref={closeRef} type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                        <button onClick={() => insertClassroom()} type="button" class="btn btn-primary">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddClassroomComponent;
